module.exports = __webpack_public_path__ + "img/roadmap-page.a46ee270.png";